import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './nextUserTasteComparisonQuery.gql';
import { UserTasteComparisonFragmentDoc } from '../../fragments/eat/UserTasteComparisonFragment.generated';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type NextUserTasteComparisonQuery_nextUserTasteComparison_UserTasteComparison_leftMenuItem_MenuItem_featuredPhoto_MenuItemPosPhoto = {
  __typename: 'MenuItemPosPhoto',
  id: number,
  photoUrl?: string | null
};

export type NextUserTasteComparisonQuery_nextUserTasteComparison_UserTasteComparison_leftMenuItem_MenuItem_featuredPhoto_Photo = {
  __typename: 'Photo',
  id: number,
  photoUrl?: string | null
};

export type NextUserTasteComparisonQuery_nextUserTasteComparison_UserTasteComparison_leftMenuItem_MenuItem_featuredPhoto =
  | NextUserTasteComparisonQuery_nextUserTasteComparison_UserTasteComparison_leftMenuItem_MenuItem_featuredPhoto_MenuItemPosPhoto
  | NextUserTasteComparisonQuery_nextUserTasteComparison_UserTasteComparison_leftMenuItem_MenuItem_featuredPhoto_Photo
;

export type NextUserTasteComparisonQuery_nextUserTasteComparison_UserTasteComparison_leftMenuItem_MenuItem_location_RestaurantLocation = {
  __typename: 'RestaurantLocation',
  id: number,
  city: string,
  countryName: string,
  state?: string | null
};

export type NextUserTasteComparisonQuery_nextUserTasteComparison_UserTasteComparison_leftMenuItem_MenuItem_restaurant_Restaurant = {
  __typename: 'Restaurant',
  id: number,
  name: string
};

export type NextUserTasteComparisonQuery_nextUserTasteComparison_UserTasteComparison_leftMenuItem_MenuItem = {
  __typename: 'MenuItem',
  id: number,
  description?: string | null,
  displayName: string,
  featuredPhoto?: NextUserTasteComparisonQuery_nextUserTasteComparison_UserTasteComparison_leftMenuItem_MenuItem_featuredPhoto | null,
  location?: NextUserTasteComparisonQuery_nextUserTasteComparison_UserTasteComparison_leftMenuItem_MenuItem_location_RestaurantLocation | null,
  restaurant: NextUserTasteComparisonQuery_nextUserTasteComparison_UserTasteComparison_leftMenuItem_MenuItem_restaurant_Restaurant
};

export type NextUserTasteComparisonQuery_nextUserTasteComparison_UserTasteComparison_rightMenuItem_MenuItem = {
  __typename: 'MenuItem',
  id: number,
  description?: string | null,
  displayName: string,
  featuredPhoto?: NextUserTasteComparisonQuery_nextUserTasteComparison_UserTasteComparison_leftMenuItem_MenuItem_featuredPhoto | null,
  location?: NextUserTasteComparisonQuery_nextUserTasteComparison_UserTasteComparison_leftMenuItem_MenuItem_location_RestaurantLocation | null,
  restaurant: NextUserTasteComparisonQuery_nextUserTasteComparison_UserTasteComparison_leftMenuItem_MenuItem_restaurant_Restaurant
};

export type NextUserTasteComparisonQuery_nextUserTasteComparison_UserTasteComparison = {
  __typename: 'UserTasteComparison',
  id?: number | null,
  roundPickNumber: number,
  leftMenuItem?: NextUserTasteComparisonQuery_nextUserTasteComparison_UserTasteComparison_leftMenuItem_MenuItem | null,
  rightMenuItem?: NextUserTasteComparisonQuery_nextUserTasteComparison_UserTasteComparison_rightMenuItem_MenuItem | null
};

export type NextUserTasteComparisonQuery_Query = {
  __typename?: 'Query',
  nextUserTasteComparison?: NextUserTasteComparisonQuery_nextUserTasteComparison_UserTasteComparison | null
};


export type NextUserTasteComparisonQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type NextUserTasteComparisonQuery = NextUserTasteComparisonQuery_Query;


export const NextUserTasteComparisonDocument = /*#__PURE__*/ document as unknown as DocumentNode<NextUserTasteComparisonQuery, NextUserTasteComparisonQueryVariables>;


/**
 * __useNextUserTasteComparisonQuery__
 *
 * To run a query within a React component, call `useNextUserTasteComparisonQuery` and pass it any options that fit your needs.
 * When your component renders, `useNextUserTasteComparisonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNextUserTasteComparisonQuery({
 *   variables: {
 *   },
 * });
 */
export function useNextUserTasteComparisonQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NextUserTasteComparisonQuery, NextUserTasteComparisonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NextUserTasteComparisonQuery, NextUserTasteComparisonQueryVariables>(NextUserTasteComparisonDocument, options);
      }
export function useNextUserTasteComparisonLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NextUserTasteComparisonQuery, NextUserTasteComparisonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NextUserTasteComparisonQuery, NextUserTasteComparisonQueryVariables>(NextUserTasteComparisonDocument, options);
        }
// @ts-ignore
export function useNextUserTasteComparisonSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NextUserTasteComparisonQuery, NextUserTasteComparisonQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NextUserTasteComparisonQuery, NextUserTasteComparisonQueryVariables>;
export function useNextUserTasteComparisonSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NextUserTasteComparisonQuery, NextUserTasteComparisonQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NextUserTasteComparisonQuery | undefined, NextUserTasteComparisonQueryVariables>;
export function useNextUserTasteComparisonSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NextUserTasteComparisonQuery, NextUserTasteComparisonQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NextUserTasteComparisonQuery, NextUserTasteComparisonQueryVariables>(NextUserTasteComparisonDocument, options);
        }
export type NextUserTasteComparisonQueryHookResult = ReturnType<typeof useNextUserTasteComparisonQuery>;
export type NextUserTasteComparisonLazyQueryHookResult = ReturnType<typeof useNextUserTasteComparisonLazyQuery>;
export type NextUserTasteComparisonSuspenseQueryHookResult = ReturnType<typeof useNextUserTasteComparisonSuspenseQuery>;
export type NextUserTasteComparisonQueryResult = ApolloReactCommon.QueryResult<NextUserTasteComparisonQuery, NextUserTasteComparisonQueryVariables>;